import { z } from "zod";
import { zString } from "./commonSchemaObjects";

export const rolesCreationSchema = z.object({
  code: zString.zRequired,
  name: zString.zRequired,
  description: zString.zRequired,
});
